import { AlertType } from "@tandemdiabetes/sugarmate-api-react-client"

import { Contacts } from "../Contacts"
import { LowGlucoseThreshold } from "./LowGlucoseThreshold"
import { LowGlucoseToggle } from "./LowGlucoseToggle"
import styles from "./PhoneCallAlerts.module.scss"
import { SleepHours } from "./SleepHours"
import { useTestPhoneCallAlertFunctionality } from "./useTestPhoneCallAlertFunctionality"

import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useAlert,
  useDebouncedUpdateAlert,
} from "src/hooks"

export function PhoneCallAlerts() {
  const polyglot = usePolyglot()
  const belowNormalCall = useAlert(AlertType.BelowNormalCall)

  const {
    currentUserId,
    currentFollow,
  } = useFollowedUsers()

  const debouncedUpdatePartialAlert = useDebouncedUpdateAlert(
    belowNormalCall,
    "phone-call-alerts-update-error-toast",
  )

  const testFunctionality = useTestPhoneCallAlertFunctionality(belowNormalCall)

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.phone_call")}
      backRoutePath={currentFollow.is_self ? "/settings/alerts" : "/settings/alerts/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        {belowNormalCall && (
          <LowGlucoseToggle
            belowNormalCall={belowNormalCall}
            updateAlert={debouncedUpdatePartialAlert}
          />
        )}
        {belowNormalCall?.is_active && (
          <>
            <LowGlucoseThreshold
              belowNormalCall={belowNormalCall}
              updateAlert={debouncedUpdatePartialAlert}
            />
            <SleepHours />
            <Contacts
              maxNumberOfContacts={1}
              sugarmateAlert={belowNormalCall}
              testFunctionality={testFunctionality}
            />
          </>
        )}
      </div>
    </PageTemplate>
  )
}
